module.exports = __webpack_public_path__ + "img/4csm_Ersa-Wave-POWERFLOWPRO-01-900x675_b156afbd8a.49e8ed9b.png";